var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bottom_tab hidden-sm-and-up"},[_c('img',{attrs:{"src":require("../../assets/img/guanzhu.png"),"alt":""}}),_c('p',[_vm._v("长按识别二维码，关注亿微公众号")]),_c('div',{staticClass:"phone"},[_c('span',[_vm._v("联系电话：000-000-0000")])]),_c('div',{staticClass:"banquan"},[_vm._v("Copyright©亿微电子 . 闽ICP备10000000号")])])
}]

export { render, staticRenderFns }